import React from 'react';

// MUI
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';

const Container = styled(Grid)({
  minHeight: '100%',
  '@media (max-width: 900px)': {
    display: 'block',
  },
});

const Content = styled(Grid)({
  padding: '8px 15px 8px 8px',
  '@media (max-width: 900px)': {
    padding: '8px 8px 20px',
    maxWidth: '100%',
  },
});

// the extra bottom padding insures there is always room for the intercom button
const SidebarGrid = styled(Grid)(({ theme }) => ({
  padding: '8px 8px 100px 15px',
  borderLeft: `1px solid ${theme.palette.divider}`,
  minHeight: '100%',
  '@media (max-width: 900px)': {
    borderTop: `1px solid ${theme.palette.divider}`,
    borderLeft: 'none',
    padding: '20px 8px 100px',
    maxWidth: '100%',
  },
}));

const Sidebar = ({ children, sidebarContent }) => {
  if (!sidebarContent) {
    return <>{children}</>;
  }

  return (
    <Container container className="sidebar">
      <Content size={{ xs: 12, md: 8 }}>{children}</Content>
      <SidebarGrid size={{ xs: 12, md: 4 }}>{sidebarContent}</SidebarGrid>
    </Container>
  );
};

export default Sidebar;
